const select = () => {
	let selectsAll;
	let sortBlock = document.querySelectorAll('[data-select="select-sort"]');

	if(sortBlock.length) {
		selectsAll = sortBlock;
	} else {
		selectsAll = document.querySelectorAll('[data-select="select"]');
	}


	try {

		let parentBlock = document.querySelector('[data-block="select-wrapper"]');

		if(parentBlock) {
			
			parentBlock.addEventListener('click', (event) => {
				let target = event.target;

				if(target.dataset.select == 'select' || target.closest('.select-block')) {

					let parentSelectBlock;

					if(target.dataset.select == 'select') {
						parentSelectBlock = target;
					} else if (target.closest('.select-block')) {
						parentSelectBlock = target.closest('.select-block');
					}

					let titleSelect = parentSelectBlock.querySelector('.select-title'),
						inutSelect	= parentSelectBlock.querySelector('.input');
					
					// открыть закрыть селект
					if(parentSelectBlock.classList.contains('active')) {
						parentSelectBlock.classList.remove('active');
						removeEventListener('click', closeSelect);
					} else {
						parentSelectBlock.classList.add('active');
						addEventListener('click', closeSelect);
					}

					// подставляем значение
					if(target.classList.contains('select-item')) {
						titleSelect.textContent = target.textContent;
						
						if(inutSelect) {
							if(target.dataset.selectNum) {
								inutSelect.value = target.dataset.selectNum;
							} else {
								inutSelect.value = target.textContent;
							}

							// console.log('значение инпута - ' + inutSelect.value);
						}
		
						parentSelectBlock.classList.remove('active');
						removeEventListener('click', closeSelect);
					}


					// закрыть вне элемента
					function closeSelect(event) {
						let target = event.target;
		
						if(!parentSelectBlock.contains(target)) {
							parentSelectBlock.classList.remove('active');
							removeEventListener('click', closeSelect);
						}
					}
				}
			});
				
			
		} else {
			selectsAll.forEach(item => {
				item.addEventListener('click', openSelect);
			});
		}

		function openSelect(e) {
			let target = e.target;
			
			// открыть/закрыть селект
			let parentSelectBlock = target.closest('.select-block'),
				titleSelect = parentSelectBlock.querySelector('.select-title'),
				inutSelect	= parentSelectBlock.querySelector('.input');

			if(parentSelectBlock.classList.contains('active')) {
				parentSelectBlock.classList.remove('active');
				removeEventListener('click', closeSelect);
			} else {
				parentSelectBlock.classList.add('active');
				addEventListener('click', closeSelect);
			}

			// подставляем значение
			if(target.classList.contains('select-item')) {
				titleSelect.textContent = target.textContent;
				
				if(inutSelect) {
					if(target.dataset.selectNum) {
						inutSelect.value = target.dataset.selectNum;
					} else {
						inutSelect.value = target.textContent;
					}

					// console.log('значение инпута - ' + inutSelect.value);

					let _sort = target.getAttribute('data-sort');
					let _order = target.getAttribute('data-order');

					location.href = '/catalog/?sort=' + _sort + '&order=' + _order;
				}

				parentSelectBlock.classList.remove('active');
				removeEventListener('click', closeSelect);
				
				if(target.closest('.sorting')) {
					let titleLine = target.closest('.select-block').querySelector('.select-title');

					// titleLine.classList.remove(titleLine.classList.parentSelectBlock(1));
					// titleLine.classList.add(target.classList.parentSelectBlock(1));
				}
			}

			// закрыть вне элемента
			function closeSelect(event) {
				let target = event.target;

				if(!parentSelectBlock.contains(target)) {
					parentSelectBlock.classList.remove('active');
					removeEventListener('click', closeSelect);
				}
			}
		}

	} catch(e) {}
}
export default select;